// Dev-only client logger. Streams local events (outbound actions, inbound
// diffs/events, errors, decisions) to the server, which writes them into the
// shared transcript dir alongside its own server.jsonl. Gated to dev builds;
// a no-op in production and before a match id is set.
import { isDevBuild } from '../../devMode';
import { sendDevLog } from '../socketClient';

let _matchId = null;

// High-frequency cosmetic streams would bury the transcript. Skip them.
const SKIP = new Set(['card:pose']);

export function setDevLogMatch(matchId) {
  _matchId = matchId || null;
}

export function devLog(type, data) {
  if (!isDevBuild() || !_matchId) return;
  if (data?.type && SKIP.has(data.type)) return;
  try {
    sendDevLog(_matchId, { type, data });
  } catch { /* logging must never break the client */ }
}

// Install global error/rejection capture once, so in-match crashes land in the
// transcript instead of only the console.
let _errHooked = false;
export function installDevErrorHook() {
  if (_errHooked || typeof window === 'undefined') return;
  _errHooked = true;
  window.addEventListener('error', (e) => devLog('error', {
    message: e.message, stack: e.error?.stack, source: e.filename, line: e.lineno,
  }));
  window.addEventListener('unhandledrejection', (e) => devLog('unhandledRejection', {
    reason: String(e.reason), stack: e.reason?.stack,
  }));
}
